"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const DragAndDrop = createSVGIcon(
  <>
    <g clipPath="url(#clip0)">
      <rect width="24" height="24" fill="white" />
      <path
        d="M8.57692 18H6.5C5.39543 18 4.5 17.1046 4.5 16V6.5C4.5 5.39543 5.39543 4.5 6.5 4.5H16C17.1046 4.5 18 5.39543 18 6.5V8.57692"
        stroke="currentColor"
        strokeLinecap="round"
        strokeDasharray="2 3"
      />
      <rect
        x="7.5"
        y="7.5"
        width="13"
        height="13"
        rx="1.5"
        fill="white"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>,
  "DragAndDrop",
  {
    viewBox: "0 0 24 24",
    titleAccess: "DragAndDrop",
    fill: "none",
    height: "24px",
    width: "24px",
  }
);
